/** Debajo funciones standalone */
// https://gist.github.com/nmsdvid/8807205
export function debounce(a,b,c){var d;return function(){var e=this,f=arguments;clearTimeout(d),d=setTimeout(function(){d=null,c||a.apply(e,f)},b),c&&!d&&a.apply(e,f)}}

export function setCookie(name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '')  + expires + '; path=/';
}

export function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function eraseCookie(name) {   
    document.cookie = name+'=; Max-Age=-99999999;path=/;';  
}

export function injectScript(src, type) {

    window._injectedScripts = window._injectedScripts || [];
    
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        if (type) {
            script.type = type;
        }
        script.addEventListener('load', (e) => {
            window._injectedScripts.push(src);
            resolve(e);
        });
        script.addEventListener('error', e => reject(e.error));
        document.body.appendChild(script);
    });
}

export function injectScriptOnce(src, type) {
    window._injectedScripts = window._injectedScripts || [];

    if (window._injectedScripts.indexOf(src) > -1) {
        return new Promise((resolve, reject) => {
            resolve();
        });
    }
    
    return injectScript(src, type);
}

export function linearConversion(OldValue, OldMin, OldMax, NewMin, NewMax) {
    return (((OldValue - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin)) + NewMin;
}

export function awaitTimeout(delay) {
    return new Promise(resolve => setTimeout(resolve, delay));
}

export function getWindowScrollTop() {
    var doc = document.documentElement;
    return (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
}

export function getWindowWidth() {
    return window.innerWidth;
}

export function setCss(elements, styles, value = null) {

    if (typeof styles === 'string' && value !== null) {
        styles = {
            [styles]: value
        };
    }

    if (elements instanceof Element) {
        elements = [elements];
    } else if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    elements.forEach(element => {
        for (let property in styles) {
            element.style[property] = styles[property];
        }
    })
}

export function initAllModules(rootElement = document, moduleNames = null, args = {}) {
    let kdModules = [];
    rootElement.querySelectorAll('*[kd-module]').forEach(elm => {
        if (elm.hasAttribute('kd-initted')) {
            return;
        }
        kdModules.push(initSingleModule(elm, moduleNames, args));
    });

    return kdModules;
}

export function initSingleModule(elm, moduleNames = null, args = {}) {
    
    moduleNames = moduleNames || elm.getAttribute('kd-module');

    if (typeof moduleNames === 'function') {
        moduleNames = [moduleNames];
    } else {
        moduleNames = moduleNames.split(',').map(moduleName => moduleName.trim());
    }

    moduleNames.forEach(moduleName => {
        let moduleFn;
        if (typeof moduleName === 'function') {
            moduleFn = moduleName;
        } else {
            moduleFn = window.modules[moduleName] || window[moduleName];
        }

        if (typeof moduleFn !== 'function') {
            throw new Error(`Module ${moduleName} not found.`);
        }
        let module = new moduleFn(elm, args);
        elm.kdModule = module;
    });
    
    elm.setAttribute('kd-initted', true);
    elm.dispatchEvent(new CustomEvent('kdinit'));
   
    return elm.kdModule;
}

window.initSingleModule = initSingleModule;


export function equalizeHeightByOffset(selector, options) {

	options = Object.assign({
        property: 'minHeight',
        margin: 0,
    }, options);

	var heightByOffsetTop = {};

    let thoseElements = document.querySelectorAll(selector);

	function equalize() {
        setCss(thoseElements, {
            [options.property]: ''
        });

        thoseElements.forEach(element => {
            let offsetTop = element.getBoundingClientRect().top;
            let height 	  = element.getBoundingClientRect().height;

            if (options.property === 'minHeight') {
                heightByOffsetTop[offsetTop] = heightByOffsetTop[offsetTop] || 0;
                heightByOffsetTop[offsetTop] = Math.max(heightByOffsetTop[offsetTop], height);
            } else { // min
                heightByOffsetTop[offsetTop] = heightByOffsetTop[offsetTop] || Number.MAX_SAFE_INTEGER;
                heightByOffsetTop[offsetTop] = Math.min(heightByOffsetTop[offsetTop], height);
            }
        });

		for (let offsetTop in heightByOffsetTop) {
			var height = heightByOffsetTop[offsetTop];

            let filtered = []
            thoseElements.forEach(element => {
                let diff = Math.abs(parseInt(element.getBoundingClientRect().top, 10) - parseInt(offsetTop, 10));

                if (diff <= options.margin) {
                    filtered.push(element);
                }
            });

            filtered.forEach(element => {
                setCss(element, {
                    [options.property]: height + 'px'
                });
            });
	
		}
	}

    window.addEventListener('resize', debounce(equalize, 100));
    setTimeout(equalize, 10);

};

export function money(amount, decimals = 2) {
    let value = (amount).toLocaleString(
        'es-ES',   // leave undefined to use the visitor's browser 
                   // locale or a string like 'en-US' to override it.
        { 
            minimumFractionDigits: decimals,
            useGrouping: 'auto',
            currency: 'EUR',
            currencyDisplay: 'symbol',
            style: 'currency'
        }
    );

    return value;
}

export function unmoney(amount) {
    return amount.replace('€', '').replace('.', '').trim();
}

export function between(x, min, max) {
    return x >= min && x <= max;
}

window.hideVeil = function() {
    let veil = document.querySelector('.loadveil');
    if (!veil) {
        return;
    }

    let anim = veil.animate(
        { opacity: [1,0] }, 
        { 
            duration: 1000, 
            fill: 'forwards',
        }
    );
    anim.onfinish = function() {
        veil.style.display = 'none';
    }
}

window.showVeil = function() {
    let veil = document.querySelector('.loadveil');
    if (!veil) {
        return;
    }
    
    veil.style.display = 'block';
    veil.animate(
        { opacity: [0,1] }, 
        { 
            duration: 100, 
            fill: 'forwards',
        }
    );
}

export function changeSelectOptions(select, options) {

    if (typeof select === 'string') {
        select = document.querySelector(select);
    }
    
    let currentValue = select.value;
    
    select.innerHTML = '';

    options.forEach(option => {
        let optionElm = document.createElement('option');
        optionElm.value = option.value;
        optionElm.innerHTML = option.label;

        if (option.value === currentValue) {
            optionElm.selected = true;
        }
        select.appendChild(optionElm);
    });

}

export function filter(array, callback) {
    let filtered = [];
    array.forEach(item => {
        if (callback && callback(item)) {
            filtered.push(item);
        } else if (item) {
            filtered.push(item);
        }
    });
    return filtered;
}

export function tryJsonParse(str) {
    try {
        return JSON.parse(str);
    } catch(e) {
        return null;
    }
}

export function viewTransition(callback) {
    if (document.startViewTransition) {
        document.startViewTransition(() => {
            callback();
        });
    } else {
        callback();
    }
}

export function setLoading(container, loading) {
    let isStatic = window.getComputedStyle(container).position === 'static';

    if (loading) {
        if (isStatic) {
            container.style.position = 'relative';
        }
        container.classList.add('is-loading');
        
    } else {
        container.classList.remove('is-loading');
    }
}

export function hasVerticalScrollBar(element) {
    return element.clientHeight < element.scrollHeight;
}

export function hasHorizontalScrollBar(element) {
   return element.clientWidth < element.scrollWidth;
} 

export function animate(element, properties, duration = 400, easing = 'linear') {
    // Convert the properties object to an array of keyframes
    const keyframes = [
        {}, // Starting state (current computed values)
        properties // End state (provided values)
    ];

    // Create animation options
    const options = {
        duration: duration,
        easing: easing,
        fill: 'forwards' // Ensure the animation's effects remain after it finishes
    };

    // Use the animate method on the element
    element.animate(keyframes, options);
}

export function getSelectValues(select) {
    let result = [];
    let options = select && select.options;
    let opt;

    for (var i=0, iLen=options.length; i<iLen; i++) {
        opt = options[i];

        if (opt.selected) {
            result.push(opt.value || opt.text);
        }
    }
    return result;
}

export function randomString(length = 6) {
    return Math.random().toString(16).substring(2, length);
};

export function onDelegatedClick(parent, selector, callback, useCapture) {
    return onDelegatedEvent('click', parent, selector, callback, useCapture);
}

export function onDelegatedEvent(eventName, parent, selector, callback, useCapture) {
    return parent.addEventListener(eventName, function(e) {

        let selectorTarget = e.target.closest(selector);

        if (!selectorTarget) {
            return;
        }

        e.selectorTarget = selectorTarget;

        callback(e);
        
    }, useCapture);
}

export function onClickOutside(domElement, callback) {
    document.addEventListener('click', event => {
        if (!domElement.contains(event.target)) {
            callback(event);
        }
    });
}

/**
 * Reemplaza el contenido de un elemento identificado por un id por el de el mismo dentro del HTML pasado como parámetro.
 * @param DOMElement target 
 * @param string sourceHtml 
 * @param function callback 
 */
export function replacePageContent(target, sourceHtml, callback) {

    let domId = target.getAttribute('id');

    let html;
    let tmpDiv = document.createElement('div');
    tmpDiv.innerHTML = sourceHtml;
    let sourceElement = tmpDiv.querySelector('#' + domId);

    if (!sourceElement) {
        console.warn('Element with id ' + domId + ' not found in source html.');
        return;
    }
    
    html = sourceElement.innerHTML;

    viewTransition(() => {
        target.scrollTop = 0;
        target.innerHTML = html;
        target.style.display = '';
        initAllModules(target);
        callback && callback();
    });
}

export function addParamsToUrl(url, params) {
    let urlObj = new URL(url, window.location.origin);

    for (let key in params) {
        urlObj.searchParams.delete(key);
        urlObj.searchParams.append(key, params[key]);
    }
    return urlObj.toString();
}

export function ajaxUpdatePagePart(selector, url) {

    url = url || window.location.href;

    let request = new Request(url, {
        headers: { 'X-Is-Ajax': '1' },
    });

    let replaceTarget = document.querySelector(selector);

    setLoading(replaceTarget, true);

    fetch(request)
        .then(res => {
            return res.text();
        })
        .then(res => {
            setLoading(replaceTarget, false);

            let html;
            
            let tmpDiv = document.createElement('div');
            tmpDiv.innerHTML = res;
            let sourceElement = tmpDiv.querySelector(selector);

            if (sourceElement) {
                html = sourceElement.innerHTML;
            } else {
                html = res;
            }
            
            viewTransition(() => {
                replaceTarget.innerHTML = html;
                replaceTarget.style.display = '';
                initAllModules(replaceTarget);
            });

        }).catch(err => {
            setLoading(replaceTarget, false);
            console.error(err);
        });

}

export function isMobile() { 
    return window.innerWidth <= 767; 
}
